import React from 'react'
import { Button } from '@chakra-ui/react'
import { useAuth, useLogout } from 'hooks/auth'
import { PROTECTED, USERS } from 'lib/routes';
import { Link } from 'react-router-dom';
import Avatar from './Avatar';
import 'stylesheets/MainAppStyles/profile.css'


function ActiveUser() {
    const { user, isLoading } = useAuth();

    if (isLoading) return "Loading..."

    return (
        <>
            <Avatar user={user} />
            <h1 className='name'>{user.name} {user.lastname}</h1>
            <h2 className='username'>@{user.username}</h2>
        </>
    )
}


const Settings = () => {
    const { logout, isLoading } = useLogout();

    return (
        <div className='profile-main-container'>
            <div className="profile-container">
                <ActiveUser />
                <div className='main-buttons'></div>
                {/* <Button
                    variant="outline"
                    colorScheme="teal"
                    as={Link}
                    to={USERS}
                    className='button'
                >ALL USERS</Button> */}
                <Button
                    colorScheme='teal'
                    onClick={logout}
                    isLoading={isLoading}
                    className='button'
                >Logout
                </Button>
            </div>
        </div >
    )
}

export default Settings